<div class="dialog-wrapper" *ngIf="_commonService.getApplicationMode() != 'RM' && isCameraExist; else noCameraExist" >
    <div class="dialog-body">
        <div class="webcam">
            <div class="webcam-style">
                <webcam  [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                    *ngIf="showWebCam" [switchCamera]="nextWebcamObservable">
                </webcam>
            </div>
            <div *ngIf="showWebCam == true">
                <button type="button" (click)="takeSnapshot()" class="btn btn-primary">Take Image</button>
            </div>

            <div class="webcam-image" *ngIf="showWebCam == false">
                <div *ngIf='webcamImage'>
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="image-preview">
                    <button type="button" (click)="retake($event)" class="btn-link-image"><span>Retake</span></button>
                    <button type="button" (click)="continue($event)"
                        class="btn btn-primary"><span>Continue</span></button>
                    </div>
            </div>
        
        <div *ngIf="errors.length > 0">
            <h4>Error Message:</h4>
            <ul *ngFor="let error of errors">
                <li>{{error | json}}</li>
            </ul>
        </div>
    </div>
    </div>
</div>
<ng-template #noCameraExist>
    Camera Device not available
</ng-template>